export enum DesigningTableColumnEnum {
    Id = 1,
    Status,
    Project,
    Stage,
    Inspectors,
    CustomerManagers,
    Authors,
    GeneralContractors,
    Designers,
    GeneralDesignersManagers,
    Executors,
    FixingDeadline,
    CheckingDeadline,
    AcceptedAt,
    CreatedAt,
    UpdatedAt,
    Author,
}

export enum SortField {
    CreatedAt = 'created_at',
    UpdatedAt = 'updated_at',
}

export enum ChartColumnEnum {
    Completeness = 1,
    Connections,
    Deviation,
    Duration,
    EndDateFact,
    EndDatePlan,
    HasConnection,
    Responsible,
    StartDateFact,
    StartDatePlan,
    Weight,
}
